
import { Actions } from "@/store/enums/StoreEnums";
import { defineComponent, ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import MultiselectElement from "@vueform/multiselect";
import Datepicker from "vue3-date-time-picker";
import "vue3-date-time-picker/dist/main.css";
import { format } from "@/core/helpers/DatetimeConverter";
import { Utils } from "@/core/helpers/Utils";
interface Filter {
  status: string;
  author: boolean;
  customer: boolean;
  notifications: boolean;
}

export default defineComponent({
  name: "dropdown-1",
  components: {
    MultiselectElement,
    Datepicker,
  },
  props: {
    routeKey: String,
  },
  setup(props) {
    const store = useStore();
    const startTime = ref({ hours: 0, minutes: 0 });
    const data = ref<Filter>({
      status: "1",
      author: true,
      customer: true,
      notifications: true,
    });

    const filterRefs = {} as any;
    const getFiltersMapping = computed(() => {
      store.getters
        .getFiltersMapping({ key: props.routeKey })
        .forEach((element) => {
          filterRefs[element.name] = ref(null);
        });

      return store.getters.getFiltersMapping({ key: props.routeKey });
    });
    const getInitialFiltersMapping = () => {
      return store.getters.getInitialFiltersMapping({ key: props.routeKey });
    };

    const getFilterValues = computed(() => {
      return store.getters.getFilterValues({ key: props.routeKey });
    });
    const getDateForFilters = computed(() => {
      return store.getters.getDateForFilters({ key: props.routeKey });
    });
    onMounted(() => {
      for (const key in filterRefs) {
        if (Object.prototype.hasOwnProperty.call(filterRefs, key)) {
          //const element = filterRefs[key];
        }
      }

      //filterRefs["orderStatus"].value[0].select({ id: 5, name: "Processing" });
    });
    const applyFilters = () => {
      store.dispatch(Actions.SET_APPLIED_FILTERS_VALUES, {
        key: props.routeKey,
      });
    };
    const changeSelectValue = (newValue, attrKey) => {
      const filterSelectValue = {
        value: newValue ? newValue.id : null,
        valueText: newValue ? newValue.name : null,
        key: props.routeKey,
        attrKey: attrKey,
        clear: filterRefs[attrKey].value[0].clear,
        type: "object",
      };

      store.dispatch(Actions.SET_FILTERS_VALUE, filterSelectValue);
    };
    const changeCheckBoxValue = (newValue, valueText, attrKey) => {
      const value = newValue.target.value;
      let radioFilterValue = null as any;

      if (value == 3) {
        radioFilterValue = false;
      } else if (value == 2) {
        radioFilterValue = true;
      }
      const filterCheckboxValue = {
        value: radioFilterValue,
        valueText: valueText,
        key: props.routeKey,
        attrKey: attrKey,
        clear: () => {
          filterRefs[attrKey].value.forEach((element) => {
            if (element.value == 1) {
              element.checked = true;
            } else {
              element.checked = false;
            }
          });
          //filterRefs[attrKey].value = 1;
        },
        type: "bool",
      };

      store.dispatch(Actions.SET_FILTERS_VALUE, filterCheckboxValue);
    };
    const changeRadioButtonStaticValue = (newValue, valueText, attrKey) => {
      const value = Utils.couponStatus(newValue.target.value);
      
    
      const filterCheckboxValue = {
        value: value,
        valueText: newValue.target.value,
        key: props.routeKey,
        attrKey: attrKey,
        clear: () => {
          filterRefs[attrKey].value.forEach((element) => {
            if (element.value == value) {
              element.checked = true;
            } else {
              element.checked = false;
            }
          });
          //filterRefs[attrKey].value = 1;
        },
        type: "radio",
      };

      store.dispatch(Actions.SET_FILTERS_VALUE, filterCheckboxValue);
    };
   
    const changeDateRangeValue = (newValue, attrKey) => {
      
     
      const filterSelectValue = {
        value: format(newValue, "YYYY-MM-DD"),
        valueText: format(newValue, "YYYY-MM-DD"),
        key: props.routeKey,
        attrKey: attrKey,
        clear: filterRefs[attrKey].value[0].clearValue,
        type: "text",
      };


      store.dispatch(Actions.SET_FILTERS_VALUE, filterSelectValue);
    };
    const resetFilters = () => {
      store.dispatch(Actions.INITIALIZE_FILTER_VALUES, {
        key: props.routeKey,
        isResetFilters: true,
      });
    };

    return {
      data,
      getFiltersMapping,
      applyFilters,
      getDateForFilters,
      resetFilters,
      getFilterValues,
      startTime,
      changeSelectValue,
      changeDateRangeValue,
      filterRefs,
      changeCheckBoxValue,
      changeRadioButtonStaticValue,
      getInitialFiltersMapping,
    };
  },
});
